import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const ObjectApi = createApi({
  reducerPath: "ObjectApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    // Start Object API's------------------------------------------
    getAllObjectData: builder.query({
      query: () => "get_all_objs",
      transformResponse: (response) => response?.data || [],
    }),
    getObjectById: builder.query({
      query: ({ id }) => `objdata/${id}`,
      transformResponse: (response) => response?.data || [],
    }),

    addObject: builder.mutation({
      query: (addObject) => ({
        url: "add_obj",
        method: "POST",
        body: addObject,
      }),
    }),

    editObject: builder.mutation({
      query: (updateGroup) => ({
        url: `obj_update`,
        method: "PUT",
        body: updateGroup,
      }),
    }),

    // END Object API's------------------------------------------
  }),
});

export const {
  // object api
  useGetAllObjectDataQuery,
  useAddObjectMutation,
  useEditObjectMutation,
  useGetObjectByIdQuery,
} = ObjectApi;

export default ObjectApi;
